module.exports = __webpack_public_path__ + "img/tv_no.77281eb1.png";